import { useProfileStore } from "@/store/profiles/store"

/**
 * profileId가 변경되면 대시보드 내 QueryKey가 같이 변경되어야 합니다.
 * @deprecated js에서 선언된 값을 사용하는 방법은 좋지 않고, react 내에서 hook으로 사용해주세요.
 */
export const profileId = useProfileStore.getState().getProfileAccountId()
